import { render, staticRenderFns } from "./RegisterOnboarding.vue?vue&type=template&id=a470c156&scoped=true"
import script from "./RegisterOnboarding.vue?vue&type=script&lang=js"
export * from "./RegisterOnboarding.vue?vue&type=script&lang=js"
import style0 from "./RegisterOnboarding.vue?vue&type=style&index=0&id=a470c156&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a470c156",
  null
  
)

export default component.exports